import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

import { FilterOutlined } from "@ant-design/icons";
import { DatePicker as AntdDatePicker, Row, Space } from "antd";
import { Button } from "components/elements";
import MyTeamTimestampTable from "components/table/MyTeamTimestampTable";

function MyTeamTimestamp({
  pagination = {},
  isLoading = false,
  timestampList = [],
  onFilter = () => {},
  onExport = () => {},
  onImport = () => {},
  onDateChange = () => {},
}) {
  const { t } = useTranslation();

  return (
    <Space style={{ width: "100%" }} size={24} direction="vertical">
      <Row justify="space-between">
        <AntdDatePicker defaultValue={dayjs()} onChange={onDateChange} />
        <Space size={24}>
          <Button type="default" onClick={onFilter}>
            {t("common.filter")} <FilterOutlined />
          </Button>
          <Button type="default" onClick={onExport}>
            {t("common.export")}
          </Button>
          <Button onClick={onImport}>{t("common.import")}</Button>
        </Space>
      </Row>
      <MyTeamTimestampTable
        isLoading={isLoading}
        dataSource={timestampList}
        pagination={pagination}
      />
    </Space>
  );
}

export default MyTeamTimestamp;
